import { render, staticRenderFns } from "./InputSwitch.vue?vue&type=template&id=e4eed164"
import script from "./InputSwitch.vue?vue&type=script&lang=ts"
export * from "./InputSwitch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports